var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizontalGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.991,
    height: 10.339,
    viewBox: "0 0 14.991 10.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph_ic",
    transform: "translate(-251.851 -222.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11398",
    "data-name": "Path 11398",
    d: "M24.774,58.339a.773.773,0,0,0,.548-.227l4.363-4.363,1.778,1.778a.775.775,0,0,0,1.1,0l4.879-4.879v1.746a.775.775,0,1,0,1.551,0V48.775A.775.775,0,0,0,38.214,48H34.6a.775.775,0,0,0,0,1.551h1.747l-4.331,4.331L30.233,52.1a.775.775,0,0,0-1.1,0l-4.911,4.911a.775.775,0,0,0,.548,1.324Z",
    transform: "translate(227.853 174.07)",
    fill: "#313944"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalGraph);
export default __webpack_public_path__ + "static/media/horizontalGraph.247fbd65.svg";
export { ForwardRef as ReactComponent };